import React, { useMemo, useState, useEffect } from "react";

import DataTable, { Direction } from "react-data-table-component";
import FilterComponent from "./FilterComponent";
import axios from 'axios'
import { API_BASE_PATH, post } from "../Api";
import { FaCheck, FaCheckCircle, FaEye, FaPause, FaPhone, FaPlay, FaStop, FaTimes, FaTimesCircle } from "react-icons/fa";
import { Filter, Play,TimerIcon, StopCircle, Check, Cross, Phone, PhoneIcon, PhoneOutgoingIcon, LucidePhoneOutgoing, PhoneCall, TimerOffIcon } from "lucide-react";
import { Button, ButtonGroup, Icon, useColorModeValue } from "@chakra-ui/react";

const FILTERS = [
  { id: "all",   label: "All",   icon: Filter },
  { id: "accepted", label: "Accepted", icon: Check },
  { id: "pending", label: "Pending", icon: TimerIcon },
  { id: "rejected",  label: "Rejected",  icon: FaTimes },
  { id: "timeout",  label: "Timeout",  icon: TimerOffIcon },

];
const OneDRideConnectsTable = props => {
    const columns = [
        {
            name: "Call ID",
            selector: "id",
            sortable: true,
            cell: row =>
            (
                <div className="flex gap-2">
                       <PhoneCall color={row.status=="accepted"?"green":"red"} className="w-5 h-5"></PhoneCall>{row.id}
                </div>
            ) 
            
        },
{
        name: "Passenger",
        selector: "passenger",
        sortable: true,
        
    },
        {
            name: "Driver",
            selector: "to",
            sortable: true,
            
        }
       ,
       
       {
        name: "Call Time",
        selector: "time",
        sortable: true,
        cell: row =>
            (
                <>
                   {new Date(+(row.time||row.lastAccessDate)).toLocaleString()}
                </>
            ) 
        
    },
       
        {
            name: "Status",
            selector: "status",
            sortable: true,
            cell: row =>
            (
                <div className="flex gap-1">
                   {row.status=="accepted"?<FaCheckCircle color="green"></FaCheckCircle>:<FaTimesCircle color="red"></FaTimesCircle>} { (row.status||'unknown').toUpperCase()}
                      
                   </div>
            ) 
            
        },
        {
            name: "  Buttons  ",
            button: true,
            width: "140px" ,    
            cell: row =>
                (
                    <div className="flex items-center h-full">
                        <button
                            className="btn btn-primary btn-sm m-0 shadow-lg rounded-xl" 
                            onClick={() => props.onSelectRecord(row)}
                            style={{ marginRight: "0px",background:"black",marginRight:"2px",borderRadius:"20px"}}
                        >View Details</button>
                    </div>
                ) 
        }
    ];
    const [data, setData] = useState([]);
    const [filterText, setFilterText] = React.useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = React.useState(
        false
    );
    const filteredItems = data;
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [stateFilter, setStateFilter] = useState("all");

    var userInfo = localStorage.getItem("userInfo");
    if (userInfo) {
        userInfo = JSON.parse(userInfo);
    }
    
    const onDataFilter=val=>{
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText(val);
        fetchUsers(1,val);
    }

    useEffect(()=>{
        setResetPaginationToggle(!resetPaginationToggle);

        if(stateFilter){
            fetchUsers(1,filterText);
        }
    },[stateFilter])

    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                onDataFilter("");
            }
        };

        return (
            <FilterComponent
                onFilter={e => onDataFilter(e.target.value)}
                onFilterText={e => onDataFilter(filterText)}
                onSaveFilter={e => setFilterText(e.target.value)}
                onClear={handleClear}
                filterText={filterText}
            />
        );
    }, [filterText, resetPaginationToggle]);

   

    const fetchDataOC=async (page,filter) =>{

        var multiFilter ={
            "condition":"AND",
            "rules":[
              {
                "field": "passenger",
                "type": "string",
                "operator": "!=",
                "value": ""
              }
            ]
          }

          if(stateFilter && stateFilter!="all"){
            multiFilter.rules.push({
                "field": "status",
                "type": "string",
                "operator": "=",
                "value": stateFilter
            })
          }


        const filt = filter?{searchFilter:{
            passenger:filter,
            to:filter,
            status:filter,
            multiFilter:multiFilter
        }}:{role:"user",multiFilter:multiFilter}
        const response = await post(`/objects/zrider_driverconnect/search?partnerId=${userInfo.partnerId}&count=10&offset=${(page-1)*10}&order=lastaccessdate&dir=desc`,filt);
        setData(response.rows.map(s=>{
            s.data.id=s.dataKey;
            s.data.lastAccessDate=s.lastAccessDate;
            
            return s.data;
        }));
        let count = response.total;
        
        setTotalRows(count);
        return response.data;
    }

    const fetchUsers = async (page,filt) => {
        setLoading(true);
        await fetchDataOC(page,filt);

        setPerPage(10);
        setLoading(false);
    };

    const handlePageChange = page => {
        fetchUsers(page,filterText);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        // setLoading(true);
        // const response = await axios.get(`/objects/outletClusters?lob=${userInfo.accountId}&page=${page}&count=${newPerPage}&resolve=true`);
        // setData(response.data.data);
        // setTotalRows(response.data.length+100);
        // //setPerPage(newPerPage);
        // setLoading(false);
    };

    useEffect(() => {
        // alert("Calling")

        fetchUsers(1); // fetch page 1 of users
    }, [props.updateTime]);

    function FilterButtons({ value = "all", onChange, size = "sm" }) {
        const activeBg   = useColorModeValue("teal.500", "teal.300");
        const activeText = useColorModeValue("white", "gray.800");
      
        return (
          <ButtonGroup className="mt-2" isAttached variant="outline" size={size}>
            {FILTERS.map(({ id, label, icon }) => {
              const isActive = id === value;
              return (
                <Button
                  key={id}
                  leftIcon={<Icon as={icon} boxSize={4} />}
                  borderRadius="full"
                  bg={isActive ? activeBg   : undefined}
                  color={isActive ? activeText : undefined}
                  _hover={{ bg: isActive ? activeBg : "gray.100" }}
                  _dark={{ _hover: { bg: isActive ? activeBg : "gray.700" } }}
                  onClick={() => onChange?.(id)}
                >
                  {label}
                </Button>
              );
            })}
          </ButtonGroup>
        );
      }

    return (
        <><FilterButtons value={stateFilter} onChange={setStateFilter} size="sm"></FilterButtons> 

        <DataTable
            sortServer={true}
            onSort={(selectedColumn,direction)=>{
                console.log(selectedColumn)
                console.log(direction)

            }}
            title=""
            columns={columns}
            data={filteredItems}
            progressPending={loading}
            pagination
            paginationResetDefaultPage={resetPaginationToggle}
            paginationServer
            paginationTotalRows={totalRows}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            subHeader
            subHeaderComponent={subHeaderComponent}
        />
        </>
    );
};




export default OneDRideConnectsTable;
